import { findUserById } from "@/helpers/services/getUsers";
import { modules } from "@/helpers/variables/modules";

export const trackRoutes = [
  {
    path: "/track/users",
    name: "TrackUsers",
    component: () => import("@/views/track/users/Users.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.track,
      planProductRequired: modules.track,
      userPermissionRequired: "users",
      breadCrumb: [
        {
          text: "Início",
          to: { name: "Home" },
        },
        {
          text: "Conecta Track",
        },
      ],
    },
  },
  {
    path: "/track/user",
    name: "TrackUser",
    component: () => import("@/views/track/users/User.vue"),
    meta: {
      layout: "dashboard",
      requiresAuth: true,
      app: modules.track,
      planProductRequired: modules.track,
      userPermissionRequired: "users",
      breadCrumb(route) {
        const id = route.query.id;
        let user = findUserById(id);
        return [
          {
            text: "Início",
            to: { name: "Home" },
          },
          {
            text: "Conecta Track",
            to: { name: "TrackUsers" },
          },
          {
            text: user.name,
          },
        ];
      },
    },
  },
];
